<template>
  <v-sheet elevation="3">
    <v-form>
      <v-container fluid>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-text-field
              label="Identifiant"
              outline
              type="email"
              v-model="loginField"
              name="login"
              :error-messages="errors.collect('login')"
              v-validate="'required|email'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Mot de passe"
              outline
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              @click:append="showPassword = !showPassword"
              v-model="password"
              name="password"
              :error-messages="errors.collect('password')"
              v-validate="'required|min:8'"
            ></v-text-field>
          </v-flex>
          <v-btn outline @click="submit">Connexion</v-btn>
          <v-btn outline @click="googleLogin">Google login</v-btn>
          <v-snackbar v-model="showError" :bottom="true">
            {{ errorMessage }}
          </v-snackbar>
        </v-layout>
      </v-container>
    </v-form>
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginForm",
  data: function() {
    return {
      showPassword: false,
      loginField: "",
      password: "",
      showError: false,
      errorMessage: ""
    };
  },
  async mounted() {
    if (this.$route.query.code) {
      try {
        await this.callbackSSO(this.$route.query.code);
        this.$emit("login");
      } catch (e) {
        if (e.message === "401") {
          this.errorMessage = "Votre compte est désactivé";
        } else if (e.message === "404") {
          this.errorMessage = "Votre compte n'existe pas sur la plateforme";
        } else {
          this.errorMessage = "Une erreur interne a eu lieu";
          console.error(e);
        }
        this.showError = true;
      }
    }
  },
  methods: {
    ...mapActions("user", ["login", "callbackSSO"]),

    async submit() {
      const { password } = this;
      await this.$validator.validateAll();
      try {
        await this.login({ login: this.loginField, password });
        this.$emit("login");
      } catch (e) {
        if (e.message == 401) {
          this.errorMessage = "Identifiant ou mot de passe incorrect";
        } else {
          this.errorMessage = "Une erreur interne a eu lieu";
        }
        this.showError = true;
      }
    },

    async googleLogin() {
      window.location = `${process.env.VUE_APP_BASEURL}/login-sso`;
    }
  }
};
</script>

<style scoped></style>
